/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { icons } from '../../../../../assets';
import { EOnboardingComponentsId } from '../../../../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { IRouteParams } from '../../../../../routes/constants/routesConstants';
import { openMobileChangeTariff } from '../../../../Table/actions/tableActions';
import { TTableButtonsGetTranslation } from '../useTableFooterButtons';

const useTableFooterButtonTariffChange = (
    getTranslation: TTableButtonsGetTranslation,
) => {
    const dispatch = useDispatch();

    const { clientId } = useParams<IRouteParams>();

    return {
        className: 'table-footer__link link-tariff',
        dataName: 'tariff',
        icon: icons.simCardSmallIcon,
        id: AccessComponentKeyEnum.FooterButtonTariffChange,
        onboarding: EOnboardingComponentsId.subscriberTableFooterButtonTariffChange,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonTariffChange),

        onClick: useCallback(() => {
            dispatch(openMobileChangeTariff(clientId ? { clientId } : {}));
        }, [dispatch, clientId]),
    };
};

export default useTableFooterButtonTariffChange;
